/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="93.8"
        height="95.59"
        viewBox="0 0 93.8 95.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M86.96 0H60.09a6.83 6.83 0 0 0-6.84 6.83v17.39a6.85 6.85 0 0 0 6.84 6.6h4.19v6.57a1.26 1.26 0 0 0 2 .84l8.73-7.41h12a6.89 6.89 0 0 0 6.84-6.84V6.84A6.84 6.84 0 0 0 86.96 0ZM60.09 2.5h26.87a4.34 4.34 0 0 1 4.34 4.34v17.15a4.37 4.37 0 0 1-4.34 4.34h-12.5a1.24 1.24 0 0 0-.66.29l-7 5.95v-5a1.24 1.24 0 0 0-1.25-1.25h-5.46a4.34 4.34 0 0 1-4.34-4.34V6.84a4.34 4.34 0 0 1 4.34-4.34Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M82.46 17.88a2.31 2.31 0 1 0-2.31-2.31 2.3 2.3 0 0 0 2.29 2.31M73.53 17.88a2.31 2.31 0 1 0-2.31-2.31 2.3 2.3 0 0 0 2.29 2.31M64.64 17.88a2.31 2.31 0 0 0 0-4.62 2.3 2.3 0 0 0-2.32 2.3 2.29 2.29 0 0 0 2.29 2.3"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M29.09 4.02H6a6 6 0 0 0-6 6v15a6.08 6.08 0 0 0 6 5.82h10.15l7.43 6.31.1.08a1.26 1.26 0 0 0 1.75-.25 1.27 1.27 0 0 0 .25-.75v-5.39h3.41a6 6 0 0 0 6-6V10.07a6 6 0 0 0-6-6ZM6.03 6.5h23.06a3.54 3.54 0 0 1 3.55 3.55v14.74a3.55 3.55 0 0 1-3.55 3.5h-4.81a1.22 1.22 0 0 0-1.12 1.24v3.93l-5.68-4.87a1.21 1.21 0 0 0-.8-.3H6a3.57 3.57 0 0 1-3.54-3.54V10.07A3.53 3.53 0 0 1 5.97 6.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M9.91 19.5a2 2 0 1 1 2-2 2 2 0 0 1-2 2M17.53 19.5a2 2 0 1 1 2-2 2 2 0 0 1-2 2M25.15 19.5a2 2 0 1 1 2-2 2 2 0 0 1-2 2"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M55.75 47.42H33.36v33.59h22.39Zm-2.5 2.5V78.5H35.86V49.92Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M47.62 87.05a3.07 3.07 0 1 1-3.08-3.06 3.06 3.06 0 0 1 3.06 3.06"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M60.6 40.08H28.51a1.25 1.25 0 0 0-1.25 1.25v53a1.24 1.24 0 0 0 1.25 1.25H60.6a1.24 1.24 0 0 0 1.25-1.25V41.29a1.25 1.25 0 0 0-1.25-1.21Zm-1.25 2.5v50.5H29.76v-50.5Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'MobileDeviceWithTwoWordBubblesIcon';

export default Icon;
